export const normalSize = {
	cardSize: 304,
	cardMargin: 50,
	arowLength: 120,
	arrowSize: 100,
	describeSize: 16,
	buttonSize: 20,
	priceSize: 25,
	mediaHeight: 500,
	blackArrow: false,
};

export const littleSize = {
	cardSize: 250,
	cardMargin: 30,
	arowLength: 120,
	arrowSize: 85,
	describeSize: 14,
	buttonSize: 16,
	priceSize: 20,
	mediaHeight: 450,
	blackArrow: true,
};
